import {InjectionToken} from '@angular/core';

export const TRANSLATION_BASE = new InjectionToken('translationBase');
